import script from "./PlatformList.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatformList.vue?vue&type=script&lang=ts&setup=true"

export default script